// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"365":"cdf6ca78","656":"b058c8c5"}[chunkId] + ".js";
};